export default "__VITE_ASSET__483e4785__"